import { computed } from "vue";
import { useIsScreenLarge } from "vue-app/composables/useIsScreenLarge/useIsScreenLarge.composable";

export function useIsScreenMobile() {
  const { isScreenLarge } = useIsScreenLarge();
  const isMobile = computed(() => !isScreenLarge.value);

  return { isMobile };
}
